import { FlagState } from '../libs';

export const FLAG_SUP_FEATURES: FlagState = {
  WEBAPP_RETURN_REQUEST: true,
  epic_ecom_269: false,
  epic_pb_613: false,
  epic_omni_389: false,
  MML_NO_PAYMENT: false,
  epic_omni_677: false,
  epic_omni_964: true,
  epic_ecom_284: false,
  epic_ecom_460: false,
  omni_848_consumer: true,
  epic_ecom_315: false,
  epic_omni_1237: false,
  epic_ecom_479: false,
  epic_ecom_483: false,
  epic_ma_150: false,
  epic_omni_1034: false,
  epic_omni_1403: false,
  epic_omni_1358: false,
  epic_ma_229: false,
  epic_ma_79: false,
  epic_omni_1459: false,
  epic_omni_1552: false,
  epic_omni_1359: false,
};
